// btw-front/src/components/admin/dashboard/SignupKindBadge.jsx
// 가입 신청 유형 표시 — 관리자 목록(SignupsTab)·상세(SignupDetailModal) 공용.
//   - 기존 회사 가입(requestKind='member'): 등록된 회사에 계정을 추가하는 신청. 승인하면 그 회사 계정이 1개 늘어난다
//   - 대기 중인 신규 회사 가입 + 같은 사업자번호 회사 있음(matchType='existing'): 승인하면 서버가 409 로 막는다
//     → 반려하고 '기존 회사 가입' 으로 다시 신청하도록 안내해야 하는 건이라 경고 톤으로 구분
//   - 신규 회사 가입: 승인하면 회사가 새로 등록된다
import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "../../ui/Badge";

// '등록된 사업자번호'(duplicate) 는 **대기 중인** 신규 회사 신청에만 붙인다.
//   matchType='existing' 은 "지금 같은 사업자번호의 활성 회사가 있다" 는 뜻일 뿐이라, 이미 승인된 신규 회사
//   신청은 자기가 만든 회사와 번호가 같아 항상 existing 이 된다 → 승인·반려가 끝난 신청은 원래 유형으로 보인다.
export function kindOf(signup) {
  if (!signup) return null;
  if (signup.requestKind === "member") return "member";
  if (signup.status === "pending" && signup.matchType === "existing") return "duplicate";
  return "company";
}

export function SignupKindBadge({ signup }) {
  const { t } = useTranslation();
  const kind = kindOf(signup);
  if (kind === "member") return <Badge tone="review">{t("admin.signup.memberSignup")}</Badge>;
  if (kind === "duplicate")
    return <Badge tone="pending">{t("admin.signup.duplicateCompany")}</Badge>;
  return <Badge tone="done">{t("admin.signup.newCompany")}</Badge>;
}

// 상세 모달 상단 안내 — 승인하면 무엇이 생기는지(또는 왜 승인할 수 없는지)
export function SignupKindHint({ signup }) {
  const { t } = useTranslation();
  const kind = kindOf(signup);
  if (!signup || signup.status !== "pending" || kind === "company") return null;
  const isMember = kind === "member";
  const companyName = (signup.matchedPartner && signup.matchedPartner.companyName) || "-";
  return (
    <p
      className={`mb-2 rounded-lg border px-3 py-2 text-xs leading-relaxed ${
        isMember
          ? "border-slate-200 bg-slate-50 text-slate-700"
          : "border-amber-200 bg-amber-50 text-amber-900"
      }`}
    >
      {isMember
        ? t("admin.signup.memberSignupHint", { company: companyName })
        : t("admin.signup.duplicateCompanyHint", { company: companyName })}
    </p>
  );
}
